import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IPartner } from 'clickNgo/entities/partner/models'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IForm } from 'core-components/classes/models/IForm'
import { CrudStore } from 'core/types/crudStore'

import { mapPartnerFromPartnerAllDataRegions } from './mapping/mapPartnerFromPartnerAllDataRegions'

export const fetchPartnerById = async (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<IPartner> => {
  const partnerCrud = CrudStore.get(CrudStoreItem.WW_Partners, options?.cacheKey)
  return partnerCrud
    .getById({ id: partnerId, force: options?.isForce, keyField: 'PartnerID' })
    .then((result: IForm) => result && mapPartnerFromPartnerAllDataRegions(result))
}
